<template>
    <el-dialog
      class="detail-info-dia"
      title="添加文件存档"
      :visible.sync="isShow"
      :close-on-click-modal="false"
      :width="dw"
      top="12vh">
        <vue-scroll :ops="vuescrollOpt">
        <el-form :model="credential" label-width="90px" class="blackListForm" :rules="formRules" ref="form" style="max-height:625px">
            <el-form-item label="证件号" prop="id_number">
                <el-input placeholder="请输入证件号" maxlength="18" :disabled="notEdit"  v-model.trim="credential.id_number" ></el-input>
            </el-form-item>
            <el-form-item label="姓名"  prop="name">
                <el-input placeholder="请输入姓名" v-model.trim="credential.name"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobile_phone">
                <el-input placeholder="请输入手机号"  v-model.trim="credential.mobile_phone"></el-input>
            </el-form-item>
            <el-form-item label="文件标题" prop="credential_title" >
                <el-input placeholder="请输入文件标题"  v-model.trim="credential.credential_title"></el-input>
            </el-form-item>
            
            <el-form-item label="备注" >
                <el-row style="position: relative">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 7}"  maxlength="200" style="width: 100% " placeholder="请输入备注" v-model="credential.remark"></el-input>
                    <span class="num" style="position: absolute;bottom: -10px;right: 10px">{{credential.remark.length}}/200</span>
                </el-row>
            </el-form-item>
            <el-form-item label="附件上传">
                <el-upload
                  ref="uploadFile"
                  action="/api/enroll/upload_enroll_file.json"
                  :file-list="credential.files"
                  :headers="fileUpHeaders"
                  :data="fileUpParam"
                  :before-upload="beforeUpload"
                  :on-progress="isUping"
                  :on-error="uploadError"
                  :on-success="uploadSuccess"
                  :on-remove="fileRemove"
                >
                    <el-button type="primary">点击上传</el-button>
                    <div slot="tip" class>只能上传jpg/png/pdf/xlsx/xls/docx/doc文件，且文件大小不能超过200M</div>
                </el-upload>
            </el-form-item>
            <div class="btns">
                <el-button type="primary" @click="sureSubmit" :loading="loading" :disabled="loading">确定</el-button>
                <el-button type="danger" @click="cancel">取消</el-button>
            </div>
        </el-form>
        </vue-scroll>
    </el-dialog>
</template>

<script>
  import {punish_type_list} from "@/assets/js/select";
  import { getUserInfo,createCredential } from '@/api/document/document';
  import formRules from '@/minix/Credential'
  import { storageData } from "@/assets/js/storage";
  import createScrollOpt from "@/assets/js/vuescrollOption";
  export default {
    name: "addCredential",
    mixins:[formRules],
    data(){
      return{
        punish_type_list,
        loading:false,
        notEdit:false,
        submitDisabled: false,
        vuescrollOpt: createScrollOpt(),
        fileUpHeaders: { "X-Token": storageData.getToken(),"X-UserType":storageData.getUserType() },
        fileUpParam: {},
        credential:{
          name:'',
          mobile_phone:'',
          id_number:'',
          credential_title:'',
          files: [],
          remark:''
        }
      }
    },
    created(){
      if (Object.keys(this.Info).length>0){
        Object.assign(this.credential,this.Info)
        this.notEdit=true
      }
    },
    props:{
      showAddDialog:{
        type:Boolean,
        required:true,
        default: false,
      },
      Info:{
        type:Object,
        required :false
      },
      dw:{
        default:'500px',
        required:false,
      }
    },
    computed: {
      isShow: {
        get(){
          return this.showAddDialog;
        },
        set(bool){
          // 参数1：是否显示弹窗
          // 参数2：是否点击确定按钮
          this.$emit("hideTips", bool, false);
        }
      },
    },
    methods:{
      beforeUpload(file) {
        if (file.size > 200 * 1024 * 1024) {
          this.$message.error("文件大小不能超过200M!");
          return false;
        }
        if (!/^.*\.(jpg|jpeg|png|pdf|xlsx|xls|docx|doc)$/i.test(file.name)) {
          this.$message.error("请上传 jpg png pdf xlsx xls docx doc格式的文件!");
          return false;
        }
        let param = {
          document: file
        };
        for (const key in param) {
          if (param.hasOwnProperty(key)) {
            this.$set(this.fileUpParam, key, param[key]);
          }
        }
      },
      isUping() {
        this.submitDisabled = true;
      },
      uploadError() {
        this.submitDisabled = false;
      },
      uploadSuccess(res) {
        this.submitDisabled = false;
        if (Number(res.status) === 0) {
          this.credential.files.push({ url: res.result.document_url, name: res.result.document_name })
        } else {
          this.$nextTick(() => { });
          this.$message.error(res.msg);
        }
      },
      fileRemove(file, fileList) {
        this.credential.files = fileList;
      },
      cancel(){
        this.isShow=false;
      },
      sureSubmit(){
        this.$refs["form"].validate((valid) => {
          if (valid){
            if(this.credential.files.length===0){
              this.$message.error('请至少上传一个文件')
              return
            }
            this.loading=true;
            createCredential({
              id_number:this.credential.id_number,
              coach_name:this.credential.name,
              coach_mobile_phone:this.credential.mobile_phone,
              credential_title:this.credential.credential_title,
              remark:this.credential.remark,
              file_list: JSON.stringify(this.credential.files.map(item => ({
                document_url: item.url,
                document_name: item.name,
              })))
            }).then(res=>{
              if (res.data.status===0){
                this.loading=false;
                this.$emit("hideTips", false, true);
              }else{
                this.$message.error(res.data.msg);
                this.loading=false
              }
            }).catch(error=>{
              this.loading=false
            })
          } else{
            this.$message.error('请填写所有带*号的必填项')
          }
        })
        
      }
    },
    components:{
      "image-up": () => import("@/components/UpImage/UpImage"),
    }
  }
</script>

<style scoped lang="stylus">
    .blackListForm
        padding-right 20px
        .btns
            display flex
            justify-content: center
    .el-dialog__body{
        padding-right: 0;
    }
</style>
